import { render, staticRenderFns } from "./UserGenerateToken.vue?vue&type=template&id=6a49b6e1&scoped=true&"
import script from "./UserGenerateToken.vue?vue&type=script&lang=js&"
export * from "./UserGenerateToken.vue?vue&type=script&lang=js&"
import style0 from "./UserGenerateToken.vue?vue&type=style&index=0&id=6a49b6e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49b6e1",
  null
  
)

export default component.exports